import React, { Component } from 'react';
import { connect } from 'react-redux'
import { supervisorChatSVG } from '../../Images/ChatSVG';
import { closeSvg } from '../../Images/GenericSVG';
import { messageToSupervisor } from '../../redux/actions/A_messages_to_SM';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { activateWorkAction } from '../../redux/actions/A_workBar_selected'
import { Singleton } from '../../js/Singleton';
import { insertWindow } from '../../redux/actions/A_draggable_windows_controller'
import { supervisorChatFloating } from '../../js/draggableComponents';
import { supervisorChatExpanded } from '../../js/ExpandedComponents'
import { deleteChatNotifications } from '../../redux/actions/A_other_actions';

class AlertMessageSupervisor extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    this.state = {
      hiddeAlert: false,
      currentSupervisor: this.props.messageFrom,
      messageArrived: this.props.message,
      textToSend: "",
      sendResponse: false,
      canResponse: this.props.canResponse
    }
    this.language = new Singleton();
    this.hiddeAlertTimer = null;
    this.deleteAlertTimer = null;
  }
  componentDidMount() {
    let _this = this;
    this.hiddeAlertTimer = setTimeout(() => { _this.hideAlert() }, 5000);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      canResponse: nextProps.canResponse,
    })
  }
  componentWillUnmount() {
    clearTimeout(this.hiddeAlertTimer);
    clearTimeout(this.deleteAlertTimer);
  }
  sendChat() {
    var currentTime = new Date().toLocaleTimeString();
    let messageToList = { type: 1, user: this.sharedData.getUserData().Login, text: this.state.textToSend, hour: currentTime };
    this.sharedData.setObjectChat(messageToList, this.state.currentSupervisor);
    this.props.messageToSupervisor(this.state.textToSend, this.state.currentSupervisor);
    this.hideAlert();
  }
  responseMessage(e) {
    this.setState({ sendResponse: true });
    clearTimeout(this.hiddeAlertTimer);
    e.stopPropagation();
  }
  hideAlert = () => {
    this.setState({ hiddeAlert: true });
    let _this = this;
    this.deleteAlertTimer = setTimeout(() => { _this.props.deleteAlert(_this.props.index) }, 250);
  }
  openChat = () => {
    this.sharedData.setWindowChatOpen(true);
    this.sharedData.setNewNotificationChat(this.state.currentSupervisor, true);
    this.sharedData.setCurrentSuperVisor(this.state.currentSupervisor);
    this.setState({ hiddeAlert: true });
    let props = { screenChat: true, currentSupervisor: this.state.currentSupervisor };
    this.sharedData.setChatWindowOpen(true);
    this.props.activateWorkAction(supervisorChatExpanded(props));
    this.props.insertWindow(supervisorChatFloating(props), true);

    setTimeout(() => { this.props.deleteChatNotifications(); }, 200);
    this.props.onOpenChat();
    let _this = this;
    _this.props.deleteAlert(_this.props.index);

  }
  render() {
    return (
      <div className={"alertChatComponent " + (this.state.sendResponse ? "onResponse " : "") + (this.state.hiddeAlert ? "hidden " : "") + (this.sharedData.getIsInactiveState() ? "disabled" :"")} 
      onClick={this.openChat}>
        <div className="marginLeft"></div>
        <div className="iconAlertMessage">{supervisorChatSVG}</div>
        <div className={"infoAlertMessage " + ((this.state.sendResponse || !this.state.canResponse) ? "onResponse " : "")}>
          <p className="titleAlertMessage">{this.state.currentSupervisor}</p>
          <p className={"textAlertMessage " + (this.state.sendResponse ? "onResponse " : "onNormal")}>{this.state.messageArrived}</p>
        </div>
        {this.state.sendResponse && <div className={"closeAlertMessage"} onClick={this.hideAlert}>{closeSvg}</div>}
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    messageToSupervisor: (message, supervisor) => { dispatch(messageToSupervisor(message, supervisor)); },
    activateWorkAction: (action) => { dispatch(activateWorkAction(action)); },
    insertWindow: (dragWindow, closeComponentIfOpen) => { dispatch(insertWindow(dragWindow, closeComponentIfOpen)); },
    deleteChatNotifications: () => { dispatch(deleteChatNotifications()); },
  });
}
export default AlertMessageSupervisor = connect(
  null,
  mapDispatchToProps
)(AlertMessageSupervisor);




// WEBPACK FOOTER //
// ./src/components/Alerts/AlertMessageSupervisor.jsx